const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;
const HAS_TIME_PATTERN = /T\d{2}:\d{2}/;

/**
 * Formats MDX `publishedAt` for blog cards and the latest-post feature.
 * Date-only values (YYYY-MM-DD) are treated as local calendar dates so
 * UTC midnight does not shift the day in Western timezones.
 */
export function formatBlogPublishedAt(publishedAt: string): string {
  const dateOnlyMatch = DATE_ONLY_PATTERN.exec(publishedAt);
  if (dateOnlyMatch) {
    const year = Number(dateOnlyMatch[1]);
    const monthIndex = Number(dateOnlyMatch[2]) - 1;
    const dayOfMonth = Number(dateOnlyMatch[3]);
    const localDate = new Date(year, monthIndex, dayOfMonth);
    return localDate.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  const publishedDate = new Date(publishedAt);
  if (Number.isNaN(publishedDate.getTime())) {
    return publishedAt;
  }

  if (HAS_TIME_PATTERN.test(publishedAt)) {
    return publishedDate.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  }

  return publishedDate.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
